import { render, staticRenderFns } from "./BrandHeader.vue?vue&type=template&id=28a9a5e8&scoped=true&"
import script from "./BrandHeader.vue?vue&type=script&lang=js&"
export * from "./BrandHeader.vue?vue&type=script&lang=js&"
import style0 from "./BrandHeader.vue?vue&type=style&index=0&id=28a9a5e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a9a5e8",
  null
  
)

export default component.exports